/* Rareva: ring size must be chosen before a ring or band can be added.

   Two different mechanisms on the two templates:

   - Engagement rings carry size as a line-item property (a select named
     properties[Ring Size]). It is marked required, but Dawn renders the product
     form with novalidate and submits over fetch, so the browser never enforces
     it - a ring could reach the cart with no size. This blocks that.

   - Wedding bands (and any other sized piece rendered by the main-product-*
     sections) carry size in the section's own control: a <select
     class="wb-size-select"> with NO name, whose value the section script
     mirrors into the hidden #right_size line-item property. That visible
     control is the one to check. The legacy rareva-ring-size-selector also
     renders a hidden, always-empty properties[Ring Size] select on those
     pages; it must be ignored, otherwise every add is blocked and the
     warning lands inside a hidden box (16 Sep 2026 fix).

   The guard covers Add to cart AND the dynamic checkout buttons (Buy with
   Shop / Shop Pay, "More payment options"). Those render inside Shopify's
   own element; the click reaches document with the host as the target, so
   the host and its wrapper are matched, not the inner button (16 Sep 2026).

   Blocking happens on the capture phase, before the theme's own submit
   handler and before Shopify's checkout handler, so nothing reaches the
   cart or checkout. */
(function () {
  if (window.__rvSizeRequired) return;
  window.__rvSizeRequired = true;

  var touched = false;
  var HOSTS = '.product-form__input, .rv-ring-size, .ring_size';
  var PAY = '.shopify-payment-button, shopify-accelerated-checkout, shopify-accelerated-checkout-cart, .shopify-payment-button__button, .shopify-payment-button__more-options';
  var TRIGGER = '[name="add"], .product-form__submit, button[type="submit"], ' + PAY;

  function css() {
    if (document.getElementById('rv-size-required-css')) return;
    var s = document.createElement('style');
    s.id = 'rv-size-required-css';
    s.textContent = [
      '.rv-size-error{display:block;margin:1.1rem 0 0;font-size:15.5px;font-weight:500;letter-spacing:.01em;line-height:1.5;color:#8a4a4a}',
      '@media (max-width:520px){.rv-size-error{font-size:15px}}',
      '.rv-size-flag select,.rv-size-flag .rv-size__field select,.rv-size-flag .rv-field select{border-color:#b98a8a!important}',
      '.rv-size-flag label{border-color:#d9bcbc!important}',
      '.rv-size-pulse{animation:rvSizePulse .6s ease}',
      '@keyframes rvSizePulse{0%,100%{box-shadow:none}35%{box-shadow:0 0 0 4px rgba(185,138,138,.18)}}'
    ].join('');
    document.head.appendChild(s);
  }

  function hidden(el) {
    if (!el) return true;
    if (el.closest('[data-rv-hidden]')) return true;
    if (el.type === 'hidden') return true;
    return false;
  }

  /* The size control that the customer actually sees. Section-rendered
     control first (bands, bracelets, necklaces), then a visible named
     properties[...size] field (engagement rings). Hidden fields are skipped. */
  function propSelect() {
    var wb = document.querySelector('.ring_size select.wb-size-select, select.wb-size-select');
    if (wb && !hidden(wb)) return wb;

    var els = document.querySelectorAll('select[name^="properties["], input[name^="properties["]');
    for (var i = 0; i < els.length; i++) {
      var n = (els[i].getAttribute('name') || '').toLowerCase();
      if (n.indexOf('size') === -1) continue;
      if (hidden(els[i])) continue;
      return els[i];
    }
    return null;
  }

  function variantGroup() {
    var groups = document.querySelectorAll('.product-form__input');
    for (var i = 0; i < groups.length; i++) {
      var lg = groups[i].querySelector('legend, .form__label');
      if (!lg) continue;
      var t = (lg.textContent || '').toLowerCase();
      if (t.indexOf('size') === -1) continue;
      if (groups[i].querySelector('select[name^="properties["]')) continue;
      return groups[i];
    }
    return null;
  }

  function hostOf(el) {
    return el.closest(HOSTS) || el.parentNode;
  }

  function warn(host, message) {
    if (!host) return;
    css();
    var note = host.querySelector('.rv-size-error');
    if (!note) {
      note = document.createElement('span');
      note.className = 'rv-size-error';
      note.setAttribute('role', 'alert');
      host.appendChild(note);
    }
    note.textContent = message;
    host.classList.add('rv-size-flag', 'rv-size-pulse');
    setTimeout(function () { host.classList.remove('rv-size-pulse'); }, 700);
    try {
      host.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } catch (e) {
      host.scrollIntoView();
    }
  }

  function clear(host) {
    if (!host) return;
    var note = host.querySelector('.rv-size-error');
    if (note && note.parentNode) { note.parentNode.removeChild(note); }
    host.classList.remove('rv-size-flag');
  }

  function blocked() {
    var sel = propSelect();
    if (sel) {
      if (!sel.value || !String(sel.value).trim()) {
        return { host: hostOf(sel), message: 'Please choose your ring size before adding to the bag.' };
      }
      clear(hostOf(sel));
      return null;
    }

    var group = variantGroup();
    if (group && !touched) {
      return { host: group, message: 'Please confirm your ring size before adding to the bag.' };
    }
    if (group) { clear(group); }
    return null;
  }

  function stop(event) {
    event.preventDefault();
    event.stopPropagation();
    if (event.stopImmediatePropagation) { event.stopImmediatePropagation(); }
  }

  function guard(event) {
    var t = event.target;
    var trigger = (t && t.closest) ? t.closest(TRIGGER) : null;
    if (event.type !== 'submit' && !trigger) return;
    if (t && t.closest && t.closest('.rv-apt, .wishlist-button')) return;

    var problem = blocked();
    if (!problem) return;

    stop(event);
    warn(problem.host, problem.message);
  }

  /* Payment buttons: also intercept the press itself, so Shopify's checkout
     handler never starts even if it listens before click. Only when blocked. */
  function payGuard(event) {
    var t = event.target;
    if (!t || !t.closest || !t.closest(PAY)) return;
    var problem = blocked();
    if (!problem) return;
    stop(event);
    warn(problem.host, problem.message);
  }

  document.addEventListener('click', guard, true);
  document.addEventListener('pointerdown', payGuard, true);
  document.addEventListener('mousedown', payGuard, true);
  document.addEventListener('touchstart', payGuard, { capture: true, passive: false });
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    payGuard(event);
  }, true);
  document.addEventListener('submit', function (event) {
    if (!event.target || !event.target.matches('form[action*="/cart/add"]')) return;
    guard(event);
  }, true);

  /* Any interaction with a size control counts as a choice. */
  document.addEventListener('change', function (event) {
    var host = event.target.closest(HOSTS);
    if (!host) return;
    var lg = host.querySelector('legend, .form__label, label.rv-lbl, .variant-title-shap');
    var t = lg ? (lg.textContent || '').toLowerCase() : '';
    var named = (event.target.getAttribute('name') || '').toLowerCase();
    var isWb = event.target.classList && event.target.classList.contains('wb-size-select');
    if (!isWb && t.indexOf('size') === -1 && named.indexOf('size') === -1) return;
    touched = true;
    clear(host);
  }, true);

  document.addEventListener('click', function (event) {
    var label = event.target.closest('.product-form__input label');
    if (!label) return;
    var host = label.closest('.product-form__input');
    var lg = host ? host.querySelector('legend, .form__label') : null;
    if (!lg || (lg.textContent || '').toLowerCase().indexOf('size') === -1) return;
    touched = true;
    clear(host);
  }, true);

  css();
})();
